// extracted by mini-css-extract-plugin
export var center = "_b-2";
export var clickableRow = "_b-5";
export var expandedRow = "_b-7";
export var hoverable = "_b-4";
export var left = "_b-1";
export var right = "_b-3";
export var row = "_b-0";
export var selectedRow = "_b-6";
export var summaryRow = "_b-8";